import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer, Zoom } from "react-toastify";
import { Helmet } from "react-helmet";
import "./App.css";
import "./css/my_css.css";
import Home from "./MainPage/Home";
import PageNotFound from "./MainPage/PageNotFound";
import Logout from "./MainPage/Logout";
import Login from "./MainPage/Login";
import MyProducts from "./MainPage/MyProducts";
import MyOrderds from "./MainPage/MyOrderds";
import MyTransaction from "./MainPage/MyTransaction";
import More from "./MainPage/More";
import Complain from "./MainPage/Complain";
import UpdateProdile from "./MainPage/UpdateProdile";
import OrderDetails from "./MainPage/OrderDetails";
import Mycart from "./MainPage/Mycart";
import AddProduct from "./MainPage/AddProduct";
import UpdateProduct from "./MainPage/UpdateProduct";
import AddComplain from "./MainPage/AddComplain";
import UpdateComplain from "./MainPage/UpdateComplain";
import UpdateBankDetails from "./MainPage/UpdateBankDetails";
import ProductDetail from "./MainPage/ProductDetail";
import Loginapp from "./MainPage/Loginapp";
import AllProducts from "./MainPage/AllProducts";
import Notification from "./MainPage/Notification";
import Index from "./subpage/Index";
import Productlist from "./subpage/Productlist";
import Profile from "./subpage/Profile";
import ProductDetailExtra from "./subpage/ProductDetailExtra";
import Size from "./subpage/Size";
import Products from "./subpage/Products";
import Terms from "./subpage/Terms";
import Privacy from "./subpage/Privacy";
import HelpAndSupport from "./subpage/HelpAndSupport";
import Inquiry from "./subpage/Inquiry";
import Scan from "./MainPage/Scan";
import PromotionalImage from "./MainPage/PromotionalImage";
import Checkuser from "./MainPage/Checkuser";
import Getlocation from "./MainPage/Getlocation";
import DownloadImage from "./MainPage/DownloadImage";
import MyDevice from "./MainPage/MyDevice";
import Downloadapp from "./MainPage/Downloadapp";
import PromotionalComment from "./MainPage/PromotionalComment";
import ScrollToTop from "./MainPage/ScrollToTop";
import Registration from "./MainPage/Registration";
import DynamicSeo from "./MainPage/DynamicSeo";
import IdlePopup from "./MainPage/IdlePopup";
import ProductDetails from "./MainPage/ProductDetails";

localStorage.setItem("version_code", "1.11");
// Live
localStorage.setItem("server_folder", "");
let server_folder = localStorage.getItem("server_folder");
localStorage.setItem("back_url", server_folder);
localStorage.setItem("server_url", server_folder + "/api_web1/");
// "homepage": "https://aghomedecor.in/",
/* <IfModule mod_rewrite.c>
  RewriteEngine On
  RewriteBase /
  # Redirect all requests to index.html except actual files and directories
  RewriteCond %{REQUEST_FILENAME} !-f
  RewriteCond %{REQUEST_FILENAME} !-d
  RewriteRule ^.*$ index.html [L,QSA]
</IfModule> */

// local
// localStorage.setItem("back_url", "");
// localStorage.setItem("server_folder", "");
// let server_folder = localStorage.getItem("server_folder");
// localStorage.setItem("server_url", server_folder + "/ag_home_decor/api_web1/");
// "proxy": "http://192.168.1.222/",
// "proxy": "http://localhost/",
/* <IfModule mod_rewrite.c>
    RewriteEngine On RewriteBase / RewriteRule ^index\.html$ - [L] RewriteCond %{REQUEST_FILENAME} !-f RewriteCond %{REQUEST_FILENAME} !-d RewriteCond %{REQUEST_FILENAME} !-l RewriteRule . /index.html [L]
</IfModule> */

const Demo = (props) => (
  <Helmet>
    <link
      rel="stylesheet"
      type="text/css"
      href={server_folder + "/styles/bootstrap.css"}
    />
    <link
      rel="stylesheet"
      type="text/css"
      href={server_folder + "/styles/style.css"}
    />
    <link
      href="https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,500,500i,700,700i,900,900i|Source+Sans+Pro:300,300i,400,400i,600,600i,700,700i,900,900i&display=swap"
      rel="stylesheet"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href={server_folder + "/fonts/css/fontawesome-all.min.css"}
    />
    <link
      rel="manifest"
      href="_manifest.json"
      data-pwa-version="set_in_manifest_and_pwa_js"
    />
    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href={server_folder + "/fmcg_upload/logo/060325021608logo1.jpg"}
    />
    {/* footer */}
    <script
      type="text/javascript"
      src={server_folder + "/scripts/bootstrap.min.js"}
    ></script>
    <script
      type="text/javascript"
      src={server_folder + "/scripts/custom.js"}
    ></script>
  </Helmet>
);

function App() {
  return (
    <BrowserRouter basename={server_folder}>
      <Demo />
      <DynamicSeo />
      <ScrollToTop />
      <IdlePopup />

      <Routes>
        <Route path="/registration" element={<Registration />} />
        <Route path="/skip" element={<Index />} />
        <Route path="/Productlist" element={<Productlist />} />
        <Route path="/Profile" element={<Profile />} />
        <Route
          path="/Product_Detail/:product_id"
          element={<ProductDetailExtra />}
        />
        <Route path="/Size/:series_id" element={<Size />} />
        <Route path="/Products/:size_id/:series_id" element={<Products />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/HelpAndSupport" element={<HelpAndSupport />} />
        <Route path="/Inquiry/:proid" element={<Inquiry />} />
        <Route path="/MyDevice" element={<MyDevice />} />
        <Route path="/Downloadapp" element={<Downloadapp />} />

        <Route path="/" element={<Home />} />
        <Route
          path="/PromotionalImage/:image/:type"
          element={<PromotionalImage />}
        />
        <Route
          path="/PromotionalComment/:id/:type"
          element={<PromotionalComment />}
        />
        <Route path="/Checkuser/:remark?" element={<Checkuser />} />
        <Route path="/Getlocation/:oid?" element={<Getlocation />} />
        <Route path="/DownloadImage/:image" element={<DownloadImage />} />
        <Route path="/scan" element={<Scan />} />
        <Route path="/Logout" element={<Logout />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/MyProducts" element={<MyProducts />} />
        <Route path="/UpdateProdile" element={<UpdateProdile />} />
        <Route path="/MyOrderds" element={<MyOrderds />} />
        <Route path="/OrderDetails/:oid" element={<OrderDetails />} />
        <Route path="/Loginapp/:dealer/:token" element={<Loginapp />} />
        <Route
          path="/ProductDetails/:product_id/:product_name"
          element={<ProductDetail />}
        />

        <Route
          path="/ProductDetailss/:product_id/:product_name"
          element={<ProductDetails />}
        />
        ProductDetails
        <Route path="/MyTransaction" element={<MyTransaction />} />
        <Route path="/AllProducts" element={<AllProducts />} />
        <Route path="/Notification" element={<Notification />} />
        <Route path="/More" element={<More />} />
        <Route path="/Mycart" element={<Mycart />} />
        <Route path="/AddProduct" element={<AddProduct />} />
        <Route path="/AddProduct/:procode" element={<AddProduct />} />
        <Route
          path="/UpdateProduct/:oid/:oname/:ogty"
          element={<UpdateProduct />}
        />
        <Route path="/Complain" element={<Complain />} />
        <Route path="/AddComplain" element={<AddComplain />} />
        <Route path="/UpdateComplain/:oid" element={<UpdateComplain />} />
        <Route path="/UpdateBankDetails" element={<UpdateBankDetails />} />
        <Route path="/*" element={<PageNotFound />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Zoom}
      />
    </BrowserRouter>
  );
}
export default App;
